import Environment from '@cobliteam/react-environments';
import { createClient } from '@prismicio/client';
import type { AllDocumentTypes } from './types/neo-midas.generated';

const env = Environment.getInstance().getEnvironment();

export const repositoryName = env.prismicRepositoryNeoMidas;

const client = createClient<AllDocumentTypes>(repositoryName);

export default client;
